import React, { useState, useEffect } from "react";
import Header from "./Header";
import Footer from "./Footer";
import "./Owl.css";
import owl1 from "../images/owl1.jpeg";
import owl2 from "../images/owl2.jpeg";

function Owl() {
  // Comments state
  const [comments, setComments] = useState([]);
  const [formData, setFormData] = useState({ name: "", email: "", message: "" });

  // Fetch comments from backend
  useEffect(() => {
    fetch("http://localhost:5000/api/owl-comments")
      .then((res) => res.json())
      .then((data) => setComments(Array.isArray(data) ? data : []))
      .catch((err) => console.error(err));
  }, []);

  // Handle input change
  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  // Handle comment submission
  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!formData.name || !formData.message) return alert("Enter your name and comment!");

    try {
      const res = await fetch("http://localhost:5000/api/owl-comments", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(formData),
      });
      const newComment = await res.json();
      setComments([newComment, ...(Array.isArray(comments) ? comments : [])]);
      setFormData({ name: "", email: "", message: "" });
    } catch (err) {
      console.error(err);
    }
  };

  return (
    <div className="owl-page">
      

      <main className="owl-content">
        {/* Hero Section */}
        <section className="owl-hero">
          <h2>Owls</h2>
          <p>Owls are nocturnal birds of prey known for their distinct calls and silent flight.</p>
        </section>

        {/* Images */}
        <section className="owl-images">
          <img src={owl1} alt="Owl 1" />
          <img src={owl2} alt="Owl 2" />
        </section>

        {/* Info Section */}
        <section className="owl-info">
          <h3>Locations</h3>
          <p>Owls can be found worldwide in forests, deserts, and grasslands. They are most active at night.</p>
        </section>

        {/* Comments Section */}
        <section className="comments-section">
          <h2>Community Comments</h2>

          <form className="comment-form" onSubmit={handleSubmit}>
            <input
              type="text"
              name="name"
              placeholder="Your Name"
              value={formData.name}
              onChange={handleChange}
              required
            />
            <input
              type="email"
              name="email"
              placeholder="Your Email (optional)"
              value={formData.email}
              onChange={handleChange}
            />
            <textarea
              name="message"
              placeholder="Write your comment..."
              value={formData.message}
              onChange={handleChange}
              required
            ></textarea>
            <button type="submit">Post Comment</button>
          </form>

          <div className="comment-list">
            {comments && comments.length > 0 ? (
              comments.map((c) => (
                <div key={c._id || c.id} className="comment">
                  <strong>{c.name}</strong> ({new Date(c.date).toLocaleString()}):
                  <p>{c.message}</p>
                </div>
              ))
            ) : (
              <p>No comments yet.</p>
            )}
          </div>
        </section>
      </main>

     
    </div>
  );
}

export default Owl;
